var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZoom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12248",
    "data-name": "Group 12248",
    transform: "translate(-905 -702)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148723",
    "data-name": "Rectangle 148723",
    width: 24,
    height: 24,
    transform: "translate(905 702)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8-zoom",
    d: "M15.656,3H8.344A5.35,5.35,0,0,0,3,8.344v7.312A5.35,5.35,0,0,0,8.344,21h7.313A5.349,5.349,0,0,0,21,15.656V8.344A5.35,5.35,0,0,0,15.656,3ZM14,14.3a.7.7,0,0,1-.7.7H9.188A2.189,2.189,0,0,1,7,12.812V9.7A.7.7,0,0,1,7.7,9h4.113A2.189,2.189,0,0,1,14,11.188Zm3,.7-2-2V11l2-2Z",
    transform: "translate(905 702)",
    fill: "#008dff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoom);
export default __webpack_public_path__ + "static/media/zoom.32307296558ef6227087e03adb5e3cec.svg";
export { ForwardRef as ReactComponent };